import './FeatureHighlight.css';
export var FeatureHighlightCloseButtonCSS = '_1in3tn42-2-0-1';
export var FeatureHighlightPointerArrowCSS = '_1in3tn41-2-0-1';
export var FeatureHighlightScrollContainerCSS = '_1in3tn40-2-0-1';